import {jsx as $1xU4C$jsx, Fragment as $1xU4C$Fragment} from "@emotion/react/jsx-runtime";
import {useMemo as $1xU4C$useMemo, Children as $1xU4C$Children, isValidElement as $1xU4C$isValidElement} from "react";
import {keyframes as $1xU4C$keyframes, css as $1xU4C$css, ClassNames as $1xU4C$ClassNames} from "@emotion/react";
import {InView as $1xU4C$InView, useInView as $1xU4C$useInView} from "react-intersection-observer";
import {isFragment as $1xU4C$isFragment} from "react-is";

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $93342add5dc68271$exports = {};
var $b828946c3a57391e$exports = {};

$parcel$export($b828946c3a57391e$exports, "AttentionSeeker", () => $b828946c3a57391e$export$1736648c5c27c79d);



const $775a2b03e866bcd9$export$e3ce947fb98643bf = (0, $1xU4C$keyframes)`
  from,
  20%,
  53%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, 0, 0);
  }

  40%,
  43% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -30px, 0) scaleY(1.1);
  }

  70% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -15px, 0) scaleY(1.05);
  }

  80% {
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, 0, 0) scaleY(0.95);
  }

  90% {
    transform: translate3d(0, -4px, 0) scaleY(1.02);
  }
`;


const $60e0e70d0ee57fd6$export$fff9462e59a6c087 = (0, $1xU4C$keyframes)`
  from,
  50%,
  to {
    opacity: 1;
  }

  25%,
  75% {
    opacity: 0;
  }
`;


const $84ec4f3762e23138$export$cc718fa79617014c = (0, $1xU4C$keyframes)`
  0% {
    transform: translateX(0);
  }

  6.5% {
    transform: translateX(-6px) rotateY(-9deg);
  }

  18.5% {
    transform: translateX(5px) rotateY(7deg);
  }

  31.5% {
    transform: translateX(-3px) rotateY(-5deg);
  }

  43.5% {
    transform: translateX(2px) rotateY(3deg);
  }

  50% {
    transform: translateX(0);
  }
`;


const $c8867408124071c8$export$f5767cd4e86f63a5 = (0, $1xU4C$keyframes)`
  0% {
    transform: scale(1);
  }

  14% {
    transform: scale(1.3);
  }

  28% {
    transform: scale(1);
  }

  42% {
    transform: scale(1.3);
  }

  70% {
    transform: scale(1);
  }
`;


const $ae66423e2feef3f1$export$821f6a9282d0ec8d = (0, $1xU4C$keyframes)`
  from,
  11.1%,
  to {
    transform: translate3d(0, 0, 0);
  }

  22.2% {
    transform: skewX(-12.5deg) skewY(-12.5deg);
  }

  33.3% {
    transform: skewX(6.25deg) skewY(6.25deg);
  }

  44.4% {
    transform: skewX(-3.125deg) skewY(-3.125deg);
  }

  55.5% {
    transform: skewX(1.5625deg) skewY(1.5625deg);
  }

  66.6% {
    transform: skewX(-0.78125deg) skewY(-0.78125deg);
  }

  77.7% {
    transform: skewX(0.390625deg) skewY(0.390625deg);
  }

  88.8% {
    transform: skewX(-0.1953125deg) skewY(-0.1953125deg);
  }
`;


const $a95daebe57b5e1e5$export$f3aaf94dc96a60de = (0, $1xU4C$keyframes)`
  from {
    transform: scale3d(1, 1, 1);
  }

  50% {
    transform: scale3d(1.05, 1.05, 1.05);
  }

  to {
    transform: scale3d(1, 1, 1);
  }
`;


const $9ca3af9dea5fe859$export$bbc07f6a19d55e88 = (0, $1xU4C$keyframes)`
  from {
    transform: scale3d(1, 1, 1);
  }

  30% {
    transform: scale3d(1.25, 0.75, 1);
  }

  40% {
    transform: scale3d(0.75, 1.25, 1);
  }

  50% {
    transform: scale3d(1.15, 0.85, 1);
  }

  65% {
    transform: scale3d(0.95, 1.05, 1);
  }

  75% {
    transform: scale3d(1.05, 0.95, 1);
  }

  to {
    transform: scale3d(1, 1, 1);
  }
`;


const $88c3a37920c89863$export$267b06a7460aa7d3 = (0, $1xU4C$keyframes)`
  from,
  to {
    transform: translate3d(0, 0, 0);
  }

  10%,
  30%,
  50%,
  70%,
  90% {
    transform: translate3d(-10px, 0, 0);
  }

  20%,
  40%,
  60%,
  80% {
    transform: translate3d(10px, 0, 0);
  }
`;


const $3a6f63f0cfcf24a9$export$8e99d6962f95c405 = (0, $1xU4C$keyframes)`
  from,
  to {
    transform: translate3d(0, 0, 0);
  }

  10%,
  30%,
  50%,
  70%,
  90% {
    transform: translate3d(-10px, 0, 0);
  }

  20%,
  40%,
  60%,
  80% {
    transform: translate3d(10px, 0, 0);
  }
`;


const $65bcd71eb9001959$export$8c0595fc0dd256ce = (0, $1xU4C$keyframes)`
  from,
  to {
    transform: translate3d(0, 0, 0);
  }

  10%,
  30%,
  50%,
  70%,
  90% {
    transform: translate3d(0, -10px, 0);
  }

  20%,
  40%,
  60%,
  80% {
    transform: translate3d(0, 10px, 0);
  }
`;


const $4fd2afcec80e2d0c$export$84fc4030631e573c = (0, $1xU4C$keyframes)`
  20% {
    transform: rotate3d(0, 0, 1, 15deg);
  }

  40% {
    transform: rotate3d(0, 0, 1, -10deg);
  }

  60% {
    transform: rotate3d(0, 0, 1, 5deg);
  }

  80% {
    transform: rotate3d(0, 0, 1, -5deg);
  }

  to {
    transform: rotate3d(0, 0, 1, 0deg);
  }
`;


const $67b2a29a5612958d$export$1362d96c12095304 = (0, $1xU4C$keyframes)`
  from {
    transform: scale3d(1, 1, 1);
  }

  10%,
  20% {
    transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg);
  }

  30%,
  50%,
  70%,
  90% {
    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);
  }

  40%,
  60%,
  80% {
    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);
  }

  to {
    transform: scale3d(1, 1, 1);
  }
`;


const $4efebc091d1cec75$export$138a91d3335be56 = (0, $1xU4C$keyframes)`
  from {
    transform: translate3d(0, 0, 0);
  }

  15% {
    transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg);
  }

  30% {
    transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg);
  }

  45% {
    transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg);
  }

  60% {
    transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg);
  }

  75% {
    transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg);
  }

  to {
    transform: translate3d(0, 0, 0);
  }
`;



var $dd2a0a37606c7cc8$exports = {};

$parcel$export($dd2a0a37606c7cc8$exports, "Reveal", () => $dd2a0a37606c7cc8$export$9a32a8eb4bb56ca3);






const $08200e99613389d0$export$82e6205b15e6c637 = (0, $1xU4C$keyframes)`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;


const $366095fe4168c22b$export$27e0c58916e1badc = (0, $1xU4C$keyframes)`
  from {
    opacity: 0;
    transform: translate3d(-100%, 100%, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;


const $c71c36ef60c84c2f$export$f72096766ea3a089 = (0, $1xU4C$keyframes)`
  from {
    opacity: 0;
    transform: translate3d(100%, 100%, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;


const $f735e05763ec9f0c$export$6ecdcdb0033d0327 = (0, $1xU4C$keyframes)`
  from {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;


const $f30cacd4a0b6f42a$export$aa45f1f50300a7c0 = (0, $1xU4C$keyframes)`
  from {
    opacity: 0;
    transform: translate3d(0, -2000px, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;


const $138b216f24cd3352$export$d8fce5eeb232a07b = (0, $1xU4C$keyframes)`
  from {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;


const $7cd8f6575a1a10fd$export$327c6b58e5f59d6f = (0, $1xU4C$keyframes)`
  from {
    opacity: 0;
    transform: translate3d(-2000px, 0, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;


const $858c9afcf5e9cc61$export$7b78ca149b3ffe20 = (0, $1xU4C$keyframes)`
  from {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;


const $829b04a741706129$export$6f5ccd79656f671 = (0, $1xU4C$keyframes)`
  from {
    opacity: 0;
    transform: translate3d(2000px, 0, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;


const $6bd5ef3c2c1dbd7b$export$777354dbc7828ff3 = (0, $1xU4C$keyframes)`
  from {
    opacity: 0;
    transform: translate3d(-100%, -100%, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;


const $bc109cfc9b233b31$export$d5bfa04a6ce7104f = (0, $1xU4C$keyframes)`
  from {
    opacity: 0;
    transform: translate3d(100%, -100%, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;


const $c2f1837e4822dc2d$export$546bb2e31f381a81 = (0, $1xU4C$keyframes)`
  from {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;


const $aa30cfc033f0c6c8$export$f18a2356a26ed325 = (0, $1xU4C$keyframes)`
  from {
    opacity: 0;
    transform: translate3d(0, 2000px, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;





function $83a0c63b7d7fa82e$export$cdf1f51c52cf49d8({ duration: duration = 1000 , delay: delay = 0 , timingFunction: timingFunction = "ease" , keyframes: keyframes = (0, $138b216f24cd3352$export$d8fce5eeb232a07b) , iterationCount: iterationCount = 1 ,  }) {
    return (0, $1xU4C$css)`
    animation-duration: ${duration}ms;
    animation-timing-function: ${timingFunction};
    animation-delay: ${delay}ms;
    animation-name: ${keyframes};
    animation-direction: normal;
    animation-fill-mode: both;
    animation-iteration-count: ${iterationCount};
  `;
}


function $1c19d828b946891f$export$bedb7023a7733221(value) {
    return value === null || value === undefined;
}
function $1c19d828b946891f$export$f832f653c73e86f8(value) {
    return typeof value === "string" || typeof value === "number" || typeof value === "boolean";
}


const $dd2a0a37606c7cc8$var$hiddenStyles = (0, $1xU4C$css)`
  opacity: 0;
`;
const $dd2a0a37606c7cc8$var$textBaseStyles = (0, $1xU4C$css)`
  display: inline-block;
  white-space: pre;
`;
const $dd2a0a37606c7cc8$export$9a32a8eb4bb56ca3 = (props)=>{
    const { cascade: cascade = false , damping: damping = 0.5 , delay: delay = 0 , duration: duration = 1000 , fraction: fraction = 0 , keyframes: keyframes = (0, $138b216f24cd3352$export$d8fce5eeb232a07b) , triggerOnce: triggerOnce = false , css: revealCss , className: className , style: style , childClassName: childClassName , childStyle: childStyle , children: children , onVisibilityChange: onVisibilityChange ,  } = props;
    const animationStyles = (0, $1xU4C$useMemo)(()=>(0, $83a0c63b7d7fa82e$export$cdf1f51c52cf49d8)({
            keyframes: keyframes,
            duration: duration
        }), [
        duration,
        keyframes
    ]);
    if ((0, $1c19d828b946891f$export$bedb7023a7733221)(children)) return null;
    if ((0, $1c19d828b946891f$export$f832f653c73e86f8)(children)) return (0, $1xU4C$jsx)($dd2a0a37606c7cc8$var$TextReveal, {
        ...props,
        animationStyles: animationStyles,
        children: String(children)
    });
    if ((0, $1xU4C$isFragment)(children)) return (0, $1xU4C$jsx)($dd2a0a37606c7cc8$var$FragmentReveal, {
        ...props,
        animationStyles: animationStyles
    });
    return (0, $1xU4C$jsx)((0, $1xU4C$Fragment), {
        children: (0, $1xU4C$Children).map(children, (node, index)=>{
            if (!/*#__PURE__*/ (0, $1xU4C$isValidElement)(node)) return null;
            const inViewStyles = [
                revealCss,
                animationStyles
            ];
            const nodeDelay = delay + (cascade ? index * duration * damping : 0);
            switch(node.type){
                case "ol":
                case "ul":
                    return (0, $1xU4C$jsx)((0, $1xU4C$ClassNames), {
                        children: ({ cx: cx  })=>(0, $1xU4C$jsx)(node.type, {
                                ...node.props,
                                className: cx(className, node.props.className),
                                style: {
                                    ...style,
                                    ...node.props.style
                                },
                                children: (0, $1xU4C$jsx)($dd2a0a37606c7cc8$export$9a32a8eb4bb56ca3, {
                                    ...props,
                                    children: node.props.children
                                })
                            })
                    });
                case "li":
                    return (0, $1xU4C$jsx)((0, $1xU4C$InView), {
                        threshold: fraction,
                        triggerOnce: triggerOnce,
                        onChange: onVisibilityChange,
                        children: ({ inView: inView , ref: ref  })=>(0, $1xU4C$jsx)((0, $1xU4C$ClassNames), {
                                children: ({ cx: cx  })=>(0, $1xU4C$jsx)(node.type, {
                                        ...node.props,
                                        ref: ref,
                                        className: cx(childClassName, node.props.className),
                                        css: inView ? inViewStyles : $dd2a0a37606c7cc8$var$hiddenStyles,
                                        style: {
                                            ...childStyle,
                                            ...node.props.style,
                                            animationDelay: nodeDelay + "ms"
                                        }
                                    })
                            })
                    });
                default:
                    return (0, $1xU4C$jsx)((0, $1xU4C$InView), {
                        threshold: fraction,
                        triggerOnce: triggerOnce,
                        onChange: onVisibilityChange,
                        children: ({ inView: inView , ref: ref  })=>(0, $1xU4C$jsx)("div", {
                                ref: ref,
                                className: className,
                                css: inView ? inViewStyles : $dd2a0a37606c7cc8$var$hiddenStyles,
                                style: {
                                    ...style,
                                    animationDelay: nodeDelay + "ms"
                                },
                                children: (0, $1xU4C$jsx)((0, $1xU4C$ClassNames), {
                                    children: ({ cx: cx  })=>(0, $1xU4C$jsx)(node.type, {
                                            ...node.props,
                                            className: cx(childClassName, node.props.className),
                                            style: {
                                                ...childStyle,
                                                ...node.props.style
                                            }
                                        })
                                })
                            })
                    });
            }
        })
    });
};
const $dd2a0a37606c7cc8$var$TextReveal = (props)=>{
    const { animationStyles: animationStyles , cascade: cascade = false , damping: damping = 0.5 , delay: delay = 0 , duration: duration = 1000 , fraction: fraction = 0 , triggerOnce: triggerOnce = false , css: revealCss , className: className , style: style , children: children , onVisibilityChange: onVisibilityChange ,  } = props;
    const { ref: ref , inView: inView  } = (0, $1xU4C$useInView)({
        triggerOnce: triggerOnce,
        threshold: fraction,
        onChange: onVisibilityChange
    });
    return cascade ? (0, $1xU4C$jsx)("div", {
        ref: ref,
        className: className,
        css: [
            revealCss,
            $dd2a0a37606c7cc8$var$textBaseStyles
        ],
        style: style,
        children: children.split("").map((char, index)=>(0, $1xU4C$jsx)("span", {
                css: inView ? animationStyles : $dd2a0a37606c7cc8$var$hiddenStyles,
                style: {
                    animationDelay: delay + index * duration * damping + "ms"
                },
                children: char
            }, index))
    }) : (0, $1xU4C$jsx)($dd2a0a37606c7cc8$var$FragmentReveal, {
        ...props,
        children: children
    });
};
const $dd2a0a37606c7cc8$var$FragmentReveal = (props)=>{
    const { animationStyles: animationStyles , fraction: fraction = 0 , triggerOnce: triggerOnce = false , css: revealCss , className: className , style: style , children: children , onVisibilityChange: onVisibilityChange ,  } = props;
    const { ref: ref , inView: inView  } = (0, $1xU4C$useInView)({
        triggerOnce: triggerOnce,
        threshold: fraction,
        onChange: onVisibilityChange
    });
    const inViewStyles = [
        revealCss,
        animationStyles
    ];
    return (0, $1xU4C$jsx)("div", {
        ref: ref,
        className: className,
        css: inView ? inViewStyles : $dd2a0a37606c7cc8$var$hiddenStyles,
        style: style,
        children: children
    });
};


function $b828946c3a57391e$var$getStyles(effect) {
    switch(effect){
        case "flash":
            return [
                (0, $60e0e70d0ee57fd6$export$fff9462e59a6c087)
            ];
        case "headShake":
            return [
                (0, $84ec4f3762e23138$export$cc718fa79617014c),
                {
                    animationTimingFunction: "ease-in-out"
                }
            ];
        case "heartBeat":
            return [
                (0, $c8867408124071c8$export$f5767cd4e86f63a5),
                {
                    animationTimingFunction: "ease-in-out"
                }
            ];
        case "jello":
            return [
                (0, $ae66423e2feef3f1$export$821f6a9282d0ec8d),
                {
                    transformOrigin: "center"
                }
            ];
        case "pulse":
            return [
                (0, $a95daebe57b5e1e5$export$f3aaf94dc96a60de),
                {
                    animationTimingFunction: "ease-in-out"
                }
            ];
        case "rubberBand":
            return [
                (0, $9ca3af9dea5fe859$export$bbc07f6a19d55e88)
            ];
        case "shake":
            return [
                (0, $88c3a37920c89863$export$267b06a7460aa7d3)
            ];
        case "shakeX":
            return [
                (0, $3a6f63f0cfcf24a9$export$8e99d6962f95c405)
            ];
        case "shakeY":
            return [
                (0, $65bcd71eb9001959$export$8c0595fc0dd256ce)
            ];
        case "swing":
            return [
                (0, $4fd2afcec80e2d0c$export$84fc4030631e573c),
                {
                    transformOrigin: "top center"
                }
            ];
        case "tada":
            return [
                (0, $67b2a29a5612958d$export$1362d96c12095304)
            ];
        case "wobble":
            return [
                (0, $4efebc091d1cec75$export$138a91d3335be56)
            ];
        case "bounce":
        default:
            return [
                (0, $775a2b03e866bcd9$export$e3ce947fb98643bf),
                {
                    transformOrigin: "center bottom"
                }
            ];
    }
}
const $b828946c3a57391e$export$1736648c5c27c79d = (props)=>{
    const { effect: effect = "bounce" , ...rest } = props;
    const [keyframes, animationCss] = (0, $1xU4C$useMemo)(()=>$b828946c3a57391e$var$getStyles(effect), [
        effect
    ]);
    return (0, $1xU4C$jsx)((0, $dd2a0a37606c7cc8$export$9a32a8eb4bb56ca3), {
        keyframes: keyframes,
        css: animationCss,
        ...rest
    });
};


var $bb6327b1f47bffee$exports = {};

$parcel$export($bb6327b1f47bffee$exports, "Bounce", () => $bb6327b1f47bffee$export$d20e79fdc3899e95);



const $f23f07773ccaa81e$export$fccebd7948554554 = (0, $1xU4C$keyframes)`
  from,
  20%,
  40%,
  60%,
  80%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }

  20% {
    transform: scale3d(1.1, 1.1, 1.1);
  }

  40% {
    transform: scale3d(0.9, 0.9, 0.9);
  }

  60% {
    opacity: 1;
    transform: scale3d(1.03, 1.03, 1.03);
  }

  80% {
    transform: scale3d(0.97, 0.97, 0.97);
  }

  to {
    opacity: 1;
    transform: scale3d(1, 1, 1);
  }
`;


const $cb0c7cbcbf809567$export$5567dcc4c3474880 = (0, $1xU4C$keyframes)`
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    transform: translate3d(0, -3000px, 0) scaleY(3);
  }

  60% {
    opacity: 1;
    transform: translate3d(0, 25px, 0) scaleY(0.9);
  }

  75% {
    transform: translate3d(0, -10px, 0) scaleY(0.95);
  }

  90% {
    transform: translate3d(0, 5px, 0) scaleY(0.985);
  }

  to {
    transform: translate3d(0, 0, 0);
  }
`;


const $0cebab2ec78c5352$export$92fd46a1c9da5ead = (0, $1xU4C$keyframes)`
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    transform: translate3d(-3000px, 0, 0) scaleX(3);
  }

  60% {
    opacity: 1;
    transform: translate3d(25px, 0, 0) scaleX(1);
  }

  75% {
    transform: translate3d(-10px, 0, 0) scaleX(0.98);
  }

  90% {
    transform: translate3d(5px, 0, 0) scaleX(0.995);
  }

  to {
    transform: translate3d(0, 0, 0);
  }
`;


const $e627ac5da737c319$export$aebe35d18555813a = (0, $1xU4C$keyframes)`
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  from {
    opacity: 0;
    transform: translate3d(3000px, 0, 0) scaleX(3);
  }

  60% {
    opacity: 1;
    transform: translate3d(-25px, 0, 0) scaleX(1);
  }

  75% {
    transform: translate3d(10px, 0, 0) scaleX(0.98);
  }

  90% {
    transform: translate3d(-5px, 0, 0) scaleX(0.995);
  }

  to {
    transform: translate3d(0, 0, 0);
  }
`;


const $ae0ebc4be3d9e415$export$9e7bc32a82042281 = (0, $1xU4C$keyframes)`
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  from {
    opacity: 0;
    transform: translate3d(0, 3000px, 0) scaleY(5);
  }

  60% {
    opacity: 1;
    transform: translate3d(0, -20px, 0) scaleY(0.9);
  }

  75% {
    transform: translate3d(0, 10px, 0) scaleY(0.95);
  }

  90% {
    transform: translate3d(0, -5px, 0) scaleY(0.985);
  }

  to {
    transform: translate3d(0, 0, 0);
  }
`;




const $8dd7d3345c71ecd6$export$cccc9e04465dce11 = (0, $1xU4C$keyframes)`
  20% {
    transform: scale3d(0.9, 0.9, 0.9);
  }

  50%,
  55% {
    opacity: 1;
    transform: scale3d(1.1, 1.1, 1.1);
  }

  to {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
`;


const $e21944c4774dcfc8$export$26ce0cf84248400c = (0, $1xU4C$keyframes)`
  20% {
    transform: translate3d(0, 10px, 0) scaleY(0.985);
  }

  40%,
  45% {
    opacity: 1;
    transform: translate3d(0, -20px, 0) scaleY(0.9);
  }

  to {
    opacity: 0;
    transform: translate3d(0, 2000px, 0) scaleY(3);
  }
`;


const $6e2056233ddc9e07$export$3dabd2f5ee26f898 = (0, $1xU4C$keyframes)`
  20% {
    opacity: 1;
    transform: translate3d(20px, 0, 0) scaleX(0.9);
  }

  to {
    opacity: 0;
    transform: translate3d(-2000px, 0, 0) scaleX(2);
  }
`;


const $d28f4592496a3ac2$export$7b4a033090b713a = (0, $1xU4C$keyframes)`
  20% {
    opacity: 1;
    transform: translate3d(-20px, 0, 0) scaleX(0.9);
  }

  to {
    opacity: 0;
    transform: translate3d(2000px, 0, 0) scaleX(2);
  }
`;


const $25ef3a9d11ae653f$export$fe9810e7e30c9caa = (0, $1xU4C$keyframes)`
  20% {
    transform: translate3d(0, -10px, 0) scaleY(0.985);
  }

  40%,
  45% {
    opacity: 1;
    transform: translate3d(0, 20px, 0) scaleY(0.9);
  }

  to {
    opacity: 0;
    transform: translate3d(0, -2000px, 0) scaleY(3);
  }
`;




function $bb6327b1f47bffee$var$getStyles(reverse, direction) {
    switch(direction){
        case "down":
            return reverse ? (0, $e21944c4774dcfc8$export$26ce0cf84248400c) : (0, $cb0c7cbcbf809567$export$5567dcc4c3474880);
        case "left":
            return reverse ? (0, $6e2056233ddc9e07$export$3dabd2f5ee26f898) : (0, $0cebab2ec78c5352$export$92fd46a1c9da5ead);
        case "right":
            return reverse ? (0, $d28f4592496a3ac2$export$7b4a033090b713a) : (0, $e627ac5da737c319$export$aebe35d18555813a);
        case "up":
            return reverse ? (0, $25ef3a9d11ae653f$export$fe9810e7e30c9caa) : (0, $ae0ebc4be3d9e415$export$9e7bc32a82042281);
        default:
            return reverse ? (0, $8dd7d3345c71ecd6$export$cccc9e04465dce11) : (0, $f23f07773ccaa81e$export$fccebd7948554554);
    }
}
const $bb6327b1f47bffee$export$d20e79fdc3899e95 = (props)=>{
    const { direction: direction , reverse: reverse = false , ...rest } = props;
    const keyframes = (0, $1xU4C$useMemo)(()=>$bb6327b1f47bffee$var$getStyles(reverse, direction), [
        direction,
        reverse
    ]);
    return (0, $1xU4C$jsx)((0, $dd2a0a37606c7cc8$export$9a32a8eb4bb56ca3), {
        keyframes: keyframes,
        ...rest
    });
};


var $adcb99eda27e89cd$exports = {};

$parcel$export($adcb99eda27e89cd$exports, "Fade", () => $adcb99eda27e89cd$export$c983850c6c9d8b0e);




const $10b9de0e704be0a9$export$c091916f1530334c = (0, $1xU4C$keyframes)`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
`;


const $c986105b0d63214f$export$19a945979f1fb3dc = (0, $1xU4C$keyframes)`
  from {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }

  to {
    opacity: 0;
    transform: translate3d(-100%, 100%, 0);
  }
`;


const $b2ae8909c8c95f0f$export$5728b370175ac481 = (0, $1xU4C$keyframes)`
  from {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }

  to {
    opacity: 0;
    transform: translate3d(100%, 100%, 0);
  }
`;


const $786dfbf27ee43a53$export$918ddd2a9d66b46e = (0, $1xU4C$keyframes)`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }
`;


const $30ecc333f4f638c6$export$658ef65a86bafcbd = (0, $1xU4C$keyframes)`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: translate3d(0, 2000px, 0);
  }
`;


const $5a5a87fc1ae727ce$export$99efea88984e567e = (0, $1xU4C$keyframes)`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }
`;


const $02f1098f7416aebc$export$3a9dc8f9529ceff5 = (0, $1xU4C$keyframes)`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: translate3d(-2000px, 0, 0);
  }
`;


const $d29cff0228f6cb2e$export$1541972369870d64 = (0, $1xU4C$keyframes)`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }
`;


const $904a461673c31049$export$d3f8667912a1aaa1 = (0, $1xU4C$keyframes)`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: translate3d(2000px, 0, 0);
  }
`;


const $7b17baffb6a876fc$export$cc0980c21917f2b0 = (0, $1xU4C$keyframes)`
  from {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }

  to {
    opacity: 0;
    transform: translate3d(-100%, -100%, 0);
  }
`;


const $c3f459764655acf7$export$510f794173174a8b = (0, $1xU4C$keyframes)`
  from {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }

  to {
    opacity: 0;
    transform: translate3d(100%, -100%, 0);
  }
`;


const $2796cd5f6b3ee53e$export$4163084011e71929 = (0, $1xU4C$keyframes)`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
`;


const $4b33f120f7b08d73$export$b0540367e09512e9 = (0, $1xU4C$keyframes)`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: translate3d(0, -2000px, 0);
  }
`;




function $adcb99eda27e89cd$var$getStyles(big, reverse, direction) {
    switch(direction){
        case "bottom-left":
            return reverse ? (0, $c986105b0d63214f$export$19a945979f1fb3dc) : (0, $366095fe4168c22b$export$27e0c58916e1badc);
        case "bottom-right":
            return reverse ? (0, $b2ae8909c8c95f0f$export$5728b370175ac481) : (0, $c71c36ef60c84c2f$export$f72096766ea3a089);
        case "down":
            return big ? reverse ? (0, $30ecc333f4f638c6$export$658ef65a86bafcbd) : (0, $f30cacd4a0b6f42a$export$aa45f1f50300a7c0) : reverse ? (0, $786dfbf27ee43a53$export$918ddd2a9d66b46e) : (0, $f735e05763ec9f0c$export$6ecdcdb0033d0327);
        case "left":
            return big ? reverse ? (0, $02f1098f7416aebc$export$3a9dc8f9529ceff5) : (0, $7cd8f6575a1a10fd$export$327c6b58e5f59d6f) : reverse ? (0, $5a5a87fc1ae727ce$export$99efea88984e567e) : (0, $138b216f24cd3352$export$d8fce5eeb232a07b);
        case "right":
            return big ? reverse ? (0, $904a461673c31049$export$d3f8667912a1aaa1) : (0, $829b04a741706129$export$6f5ccd79656f671) : reverse ? (0, $d29cff0228f6cb2e$export$1541972369870d64) : (0, $858c9afcf5e9cc61$export$7b78ca149b3ffe20);
        case "top-left":
            return reverse ? (0, $7b17baffb6a876fc$export$cc0980c21917f2b0) : (0, $6bd5ef3c2c1dbd7b$export$777354dbc7828ff3);
        case "top-right":
            return reverse ? (0, $c3f459764655acf7$export$510f794173174a8b) : (0, $bc109cfc9b233b31$export$d5bfa04a6ce7104f);
        case "up":
            return big ? reverse ? (0, $4b33f120f7b08d73$export$b0540367e09512e9) : (0, $aa30cfc033f0c6c8$export$f18a2356a26ed325) : reverse ? (0, $2796cd5f6b3ee53e$export$4163084011e71929) : (0, $c2f1837e4822dc2d$export$546bb2e31f381a81);
        default:
            return reverse ? (0, $10b9de0e704be0a9$export$c091916f1530334c) : (0, $08200e99613389d0$export$82e6205b15e6c637);
    }
}
const $adcb99eda27e89cd$export$c983850c6c9d8b0e = (props)=>{
    const { big: big = false , direction: direction , reverse: reverse = false , ...rest } = props;
    const keyframes = (0, $1xU4C$useMemo)(()=>$adcb99eda27e89cd$var$getStyles(big, reverse, direction), [
        big,
        direction,
        reverse
    ]);
    return (0, $1xU4C$jsx)((0, $dd2a0a37606c7cc8$export$9a32a8eb4bb56ca3), {
        keyframes: keyframes,
        ...rest
    });
};


var $f0d920b909797485$exports = {};

$parcel$export($f0d920b909797485$exports, "Flip", () => $f0d920b909797485$export$4d2fae537bd90431);




const $eec6c40c650fffda$export$8a83211c878a3f1f = (0, $1xU4C$keyframes)`
  from {
    transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 0) rotate3d(0, 1, 0, -360deg);
    animation-timing-function: ease-out;
  }

  40% {
    transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 150px)
      rotate3d(0, 1, 0, -190deg);
    animation-timing-function: ease-out;
  }

  50% {
    transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 150px)
      rotate3d(0, 1, 0, -170deg);
    animation-timing-function: ease-in;
  }

  80% {
    transform: perspective(400px) scale3d(0.95, 0.95, 0.95) translate3d(0, 0, 0)
      rotate3d(0, 1, 0, 0deg);
    animation-timing-function: ease-in;
  }

  to {
    transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 0) rotate3d(0, 1, 0, 0deg);
    animation-timing-function: ease-in;
  }
`;


const $d0caf64734ff9f36$export$68ed1a067f792190 = (0, $1xU4C$keyframes)`
  from {
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    animation-timing-function: ease-in;
    opacity: 0;
  }

  40% {
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    animation-timing-function: ease-in;
  }

  60% {
    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
    opacity: 1;
  }

  80% {
    transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
  }

  to {
    transform: perspective(400px);
  }
`;


const $74b6ba089c3e11bb$export$a10221d4eadc810 = (0, $1xU4C$keyframes)`
  from {
    transform: perspective(400px) rotate3d(0, 1, 0, 90deg);
    animation-timing-function: ease-in;
    opacity: 0;
  }

  40% {
    transform: perspective(400px) rotate3d(0, 1, 0, -20deg);
    animation-timing-function: ease-in;
  }

  60% {
    transform: perspective(400px) rotate3d(0, 1, 0, 10deg);
    opacity: 1;
  }

  80% {
    transform: perspective(400px) rotate3d(0, 1, 0, -5deg);
  }

  to {
    transform: perspective(400px);
  }
`;


const $3296d9d5923bb947$export$4eaf247181cd9ec3 = (0, $1xU4C$keyframes)`
  from {
    transform: perspective(400px);
  }

  30% {
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    opacity: 1;
  }

  to {
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    opacity: 0;
  }
`;


const $598ddfaf542bad06$export$93f09c73becb5407 = (0, $1xU4C$keyframes)`
  from {
    transform: perspective(400px);
  }

  30% {
    transform: perspective(400px) rotate3d(0, 1, 0, -15deg);
    opacity: 1;
  }

  to {
    transform: perspective(400px) rotate3d(0, 1, 0, 90deg);
    opacity: 0;
  }
`;




function $f0d920b909797485$var$getStyles(reverse, direction) {
    switch(direction){
        case "horizontal":
            return reverse ? (0, $3296d9d5923bb947$export$4eaf247181cd9ec3) : (0, $d0caf64734ff9f36$export$68ed1a067f792190);
        case "vertical":
            return reverse ? (0, $598ddfaf542bad06$export$93f09c73becb5407) : (0, $74b6ba089c3e11bb$export$a10221d4eadc810);
        default:
            return 0, $eec6c40c650fffda$export$8a83211c878a3f1f;
    }
}
const $f0d920b909797485$var$animationCss = (0, $1xU4C$css)`
  backface-visibility: visible;
`;
const $f0d920b909797485$export$4d2fae537bd90431 = (props)=>{
    const { direction: direction , reverse: reverse = false , ...rest } = props;
    const keyframes = (0, $1xU4C$useMemo)(()=>$f0d920b909797485$var$getStyles(reverse, direction), [
        direction,
        reverse
    ]);
    return (0, $1xU4C$jsx)((0, $dd2a0a37606c7cc8$export$9a32a8eb4bb56ca3), {
        css: $f0d920b909797485$var$animationCss,
        keyframes: keyframes,
        ...rest
    });
};


var $14213465a09382a1$exports = {};

$parcel$export($14213465a09382a1$exports, "Hinge", () => $14213465a09382a1$export$51b1a342f43475b0);



const $93fbf746a871b56c$export$321a3d0bf2c75 = (0, $1xU4C$keyframes)`
  0% {
    animation-timing-function: ease-in-out;
  }

  20%,
  60% {
    transform: rotate3d(0, 0, 1, 80deg);
    animation-timing-function: ease-in-out;
  }

  40%,
  80% {
    transform: rotate3d(0, 0, 1, 60deg);
    animation-timing-function: ease-in-out;
    opacity: 1;
  }

  to {
    transform: translate3d(0, 700px, 0);
    opacity: 0;
  }
`;


const $9b96b9cef1ba3bd6$export$51046d36a99b73b0 = (0, $1xU4C$keyframes)`
  from {
    opacity: 0;
    transform: scale(0.1) rotate(30deg);
    transform-origin: center bottom;
  }

  50% {
    transform: rotate(-10deg);
  }

  70% {
    transform: rotate(3deg);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
`;


const $8d79c6bb52991451$export$6aa1850093220a4f = (0, $1xU4C$keyframes)`
  from {
    opacity: 0;
    transform: translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;


const $1bc55f3d64a5479e$export$e78f98b32413b70e = (0, $1xU4C$keyframes)`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: translate3d(100%, 0, 0) rotate3d(0, 0, 1, 120deg);
  }
`;




const $14213465a09382a1$var$animationCss = (0, $1xU4C$css)`
  transform-origin: top left;
`;
const $14213465a09382a1$export$51b1a342f43475b0 = (props)=>{
    return (0, $1xU4C$jsx)((0, $dd2a0a37606c7cc8$export$9a32a8eb4bb56ca3), {
        css: $14213465a09382a1$var$animationCss,
        keyframes: (0, $93fbf746a871b56c$export$321a3d0bf2c75),
        ...props
    });
};


var $2e65c14677169be3$exports = {};

$parcel$export($2e65c14677169be3$exports, "JackInTheBox", () => $2e65c14677169be3$export$2d9d44ff5c623255);



const $2e65c14677169be3$export$2d9d44ff5c623255 = (props)=>{
    return (0, $1xU4C$jsx)((0, $dd2a0a37606c7cc8$export$9a32a8eb4bb56ca3), {
        keyframes: (0, $9b96b9cef1ba3bd6$export$51046d36a99b73b0),
        ...props
    });
};


var $9f6ff16b7ccd9662$exports = {};

$parcel$export($9f6ff16b7ccd9662$exports, "Roll", () => $9f6ff16b7ccd9662$export$aa11096b70371f74);




function $9f6ff16b7ccd9662$var$getStyles(reverse) {
    return reverse ? (0, $1bc55f3d64a5479e$export$e78f98b32413b70e) : (0, $8d79c6bb52991451$export$6aa1850093220a4f);
}
const $9f6ff16b7ccd9662$export$aa11096b70371f74 = (props)=>{
    const { reverse: reverse = false , ...rest } = props;
    const keyframes = (0, $1xU4C$useMemo)(()=>$9f6ff16b7ccd9662$var$getStyles(reverse), [
        reverse
    ]);
    return (0, $1xU4C$jsx)((0, $dd2a0a37606c7cc8$export$9a32a8eb4bb56ca3), {
        keyframes: keyframes,
        ...rest
    });
};


var $b3cda162b54b7f9b$exports = {};

$parcel$export($b3cda162b54b7f9b$exports, "Rotate", () => $b3cda162b54b7f9b$export$152db69a76b6b79e);



const $4c1352e04b1341e1$export$2b9048e0715456a4 = (0, $1xU4C$keyframes)`
  from {
    transform: rotate3d(0, 0, 1, -200deg);
    opacity: 0;
  }

  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
`;


const $48c780d6063bb76d$export$7336503083b51ac8 = (0, $1xU4C$keyframes)`
  from {
    transform: rotate3d(0, 0, 1, -45deg);
    opacity: 0;
  }

  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
`;


const $adf9b50c9d30b8c1$export$d39468e8ba1f782c = (0, $1xU4C$keyframes)`
  from {
    transform: rotate3d(0, 0, 1, 45deg);
    opacity: 0;
  }

  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
`;


const $2879cc390c4f9feb$export$3848addc86cdb49f = (0, $1xU4C$keyframes)`
  from {
    transform: rotate3d(0, 0, 1, 45deg);
    opacity: 0;
  }

  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
`;


const $215b25e6efaf8c40$export$bb10501f1250224d = (0, $1xU4C$keyframes)`
  from {
    transform: rotate3d(0, 0, 1, -90deg);
    opacity: 0;
  }

  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
`;




const $5e3af844b74f4a29$export$5e1ccc268ae376b0 = (0, $1xU4C$keyframes)`
  from {
    opacity: 1;
  }

  to {
    transform: rotate3d(0, 0, 1, 200deg);
    opacity: 0;
  }
`;


const $eaa7cb0a622e8248$export$fb5eb9e37db0dfef = (0, $1xU4C$keyframes)`
  from {
    opacity: 1;
  }

  to {
    transform: rotate3d(0, 0, 1, 45deg);
    opacity: 0;
  }
`;


const $1d57d92ac3de1096$export$638177b843431394 = (0, $1xU4C$keyframes)`
  from {
    opacity: 1;
  }

  to {
    transform: rotate3d(0, 0, 1, -45deg);
    opacity: 0;
  }
`;


const $3751f1834bf68f7f$export$d921b7e0db7ff86e = (0, $1xU4C$keyframes)`
  from {
    opacity: 1;
  }

  to {
    transform: rotate3d(0, 0, 1, -45deg);
    opacity: 0;
  }
`;


const $b594b4195a1f8dfb$export$43ebaa489dfc2f5d = (0, $1xU4C$keyframes)`
  from {
    opacity: 1;
  }

  to {
    transform: rotate3d(0, 0, 1, 90deg);
    opacity: 0;
  }
`;




function $b3cda162b54b7f9b$var$getStyles(reverse, direction) {
    switch(direction){
        case "bottom-left":
            return reverse ? [
                (0, $eaa7cb0a622e8248$export$fb5eb9e37db0dfef),
                {
                    transformOrigin: "left bottom"
                }
            ] : [
                (0, $48c780d6063bb76d$export$7336503083b51ac8),
                {
                    transformOrigin: "left bottom"
                }
            ];
        case "bottom-right":
            return reverse ? [
                (0, $1d57d92ac3de1096$export$638177b843431394),
                {
                    transformOrigin: "right bottom"
                }
            ] : [
                (0, $adf9b50c9d30b8c1$export$d39468e8ba1f782c),
                {
                    transformOrigin: "right bottom"
                }
            ];
        case "top-left":
            return reverse ? [
                (0, $3751f1834bf68f7f$export$d921b7e0db7ff86e),
                {
                    transformOrigin: "left bottom"
                }
            ] : [
                (0, $2879cc390c4f9feb$export$3848addc86cdb49f),
                {
                    transformOrigin: "left bottom"
                }
            ];
        case "top-right":
            return reverse ? [
                (0, $b594b4195a1f8dfb$export$43ebaa489dfc2f5d),
                {
                    transformOrigin: "right bottom"
                }
            ] : [
                (0, $215b25e6efaf8c40$export$bb10501f1250224d),
                {
                    transformOrigin: "right bottom"
                }
            ];
        default:
            return reverse ? [
                (0, $5e3af844b74f4a29$export$5e1ccc268ae376b0),
                {
                    transformOrigin: "center"
                }
            ] : [
                (0, $4c1352e04b1341e1$export$2b9048e0715456a4),
                {
                    transformOrigin: "center"
                }
            ];
    }
}
const $b3cda162b54b7f9b$export$152db69a76b6b79e = (props)=>{
    const { direction: direction , reverse: reverse = false , ...rest } = props;
    const [keyframes, animationCss] = (0, $1xU4C$useMemo)(()=>$b3cda162b54b7f9b$var$getStyles(reverse, direction), [
        direction,
        reverse
    ]);
    return (0, $1xU4C$jsx)((0, $dd2a0a37606c7cc8$export$9a32a8eb4bb56ca3), {
        css: animationCss,
        keyframes: keyframes,
        ...rest
    });
};


var $bc8935a93473b50d$exports = {};

$parcel$export($bc8935a93473b50d$exports, "Slide", () => $bc8935a93473b50d$export$d8dc01b5c85a37b9);



const $08a6d6958bce74b0$export$8775e04aa1928f66 = (0, $1xU4C$keyframes)`
  from {
    transform: translate3d(0, -100%, 0);
    visibility: visible;
  }

  to {
    transform: translate3d(0, 0, 0);
  }
`;


const $6a7df70e305e76cd$export$8da96f801aa19ebe = (0, $1xU4C$keyframes)`
  from {
    transform: translate3d(-100%, 0, 0);
    visibility: visible;
  }

  to {
    transform: translate3d(0, 0, 0);
  }
`;


const $1166e7eaf80c152f$export$706618d509d55167 = (0, $1xU4C$keyframes)`
  from {
    transform: translate3d(100%, 0, 0);
    visibility: visible;
  }

  to {
    transform: translate3d(0, 0, 0);
  }
`;


const $25db459b9b912857$export$8ce8a09eb901d11 = (0, $1xU4C$keyframes)`
  from {
    transform: translate3d(0, 100%, 0);
    visibility: visible;
  }

  to {
    transform: translate3d(0, 0, 0);
  }
`;




const $2403da231d01874f$export$4d23096b87fa05f1 = (0, $1xU4C$keyframes)`
  from {
    transform: translate3d(0, 0, 0);
  }

  to {
    visibility: hidden;
    transform: translate3d(0, 100%, 0);
  }
`;


const $b1965542e1b0fd17$export$78e157c613296941 = (0, $1xU4C$keyframes)`
  from {
    transform: translate3d(0, 0, 0);
  }

  to {
    visibility: hidden;
    transform: translate3d(-100%, 0, 0);
  }
`;


const $808371df5d376103$export$45629ceb9412b813 = (0, $1xU4C$keyframes)`
  from {
    transform: translate3d(0, 0, 0);
  }

  to {
    visibility: hidden;
    transform: translate3d(100%, 0, 0);
  }
`;


const $7dd51fec84d23796$export$341210899707327e = (0, $1xU4C$keyframes)`
  from {
    transform: translate3d(0, 0, 0);
  }

  to {
    visibility: hidden;
    transform: translate3d(0, -100%, 0);
  }
`;




function $bc8935a93473b50d$var$getStyles(reverse, direction) {
    switch(direction){
        case "down":
            return reverse ? (0, $2403da231d01874f$export$4d23096b87fa05f1) : (0, $08a6d6958bce74b0$export$8775e04aa1928f66);
        case "right":
            return reverse ? (0, $808371df5d376103$export$45629ceb9412b813) : (0, $1166e7eaf80c152f$export$706618d509d55167);
        case "up":
            return reverse ? (0, $7dd51fec84d23796$export$341210899707327e) : (0, $25db459b9b912857$export$8ce8a09eb901d11);
        case "left":
        default:
            return reverse ? (0, $b1965542e1b0fd17$export$78e157c613296941) : (0, $6a7df70e305e76cd$export$8da96f801aa19ebe);
    }
}
const $bc8935a93473b50d$export$d8dc01b5c85a37b9 = (props)=>{
    const { direction: direction , reverse: reverse = false , ...rest } = props;
    const keyframes = (0, $1xU4C$useMemo)(()=>$bc8935a93473b50d$var$getStyles(reverse, direction), [
        direction,
        reverse
    ]);
    return (0, $1xU4C$jsx)((0, $dd2a0a37606c7cc8$export$9a32a8eb4bb56ca3), {
        keyframes: keyframes,
        ...rest
    });
};


var $49c87fb6bc676a71$exports = {};

$parcel$export($49c87fb6bc676a71$exports, "Zoom", () => $49c87fb6bc676a71$export$65cfd44a2050f99);



const $f7e4d68bfafb6745$export$3b71758b3ed5255f = (0, $1xU4C$keyframes)`
  from {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }

  50% {
    opacity: 1;
  }
`;


const $0b51d5dcc7d47099$export$f1fb318c9f90bd9f = (0, $1xU4C$keyframes)`
  from {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  60% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
`;


const $15336543be08c5df$export$3b5491f6985de80 = (0, $1xU4C$keyframes)`
  from {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  60% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
`;


const $b2e140171e7136ca$export$6d68984f8269fb51 = (0, $1xU4C$keyframes)`
  from {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  60% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
`;


const $ec4613187956c5d4$export$f8e431a03d821bd2 = (0, $1xU4C$keyframes)`
  from {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  60% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
`;




const $e4125ea27977caec$export$9fdb0a49c6b4b521 = (0, $1xU4C$keyframes)`
  from {
    opacity: 1;
  }

  50% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }

  to {
    opacity: 0;
  }
`;


const $847be49731bae03b$export$10deba13beba726f = (0, $1xU4C$keyframes)`
  40% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  to {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 2000px, 0);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
`;


const $01242516c1736d7c$export$a897bc2790be434e = (0, $1xU4C$keyframes)`
  40% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(42px, 0, 0);
  }

  to {
    opacity: 0;
    transform: scale(0.1) translate3d(-2000px, 0, 0);
  }
`;


const $0a1dc9441a503604$export$23fe0a856d31fa73 = (0, $1xU4C$keyframes)`
  40% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(-42px, 0, 0);
  }

  to {
    opacity: 0;
    transform: scale(0.1) translate3d(2000px, 0, 0);
  }
`;


const $b36043e442e1ddcb$export$6c4c2ccf7a384b67 = (0, $1xU4C$keyframes)`
  40% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  to {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -2000px, 0);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
`;




function $49c87fb6bc676a71$var$getStyles(reverse, direction) {
    switch(direction){
        case "down":
            return reverse ? (0, $847be49731bae03b$export$10deba13beba726f) : (0, $0b51d5dcc7d47099$export$f1fb318c9f90bd9f);
        case "left":
            return reverse ? (0, $01242516c1736d7c$export$a897bc2790be434e) : (0, $15336543be08c5df$export$3b5491f6985de80);
        case "right":
            return reverse ? (0, $0a1dc9441a503604$export$23fe0a856d31fa73) : (0, $b2e140171e7136ca$export$6d68984f8269fb51);
        case "up":
            return reverse ? (0, $b36043e442e1ddcb$export$6c4c2ccf7a384b67) : (0, $ec4613187956c5d4$export$f8e431a03d821bd2);
        default:
            return reverse ? (0, $e4125ea27977caec$export$9fdb0a49c6b4b521) : (0, $f7e4d68bfafb6745$export$3b71758b3ed5255f);
    }
}
const $49c87fb6bc676a71$export$65cfd44a2050f99 = (props)=>{
    const { direction: direction , reverse: reverse = false , ...rest } = props;
    const keyframes = (0, $1xU4C$useMemo)(()=>$49c87fb6bc676a71$var$getStyles(reverse, direction), [
        direction,
        reverse
    ]);
    return (0, $1xU4C$jsx)((0, $dd2a0a37606c7cc8$export$9a32a8eb4bb56ca3), {
        keyframes: keyframes,
        ...rest
    });
};


$parcel$exportWildcard($93342add5dc68271$exports, $b828946c3a57391e$exports);
$parcel$exportWildcard($93342add5dc68271$exports, $bb6327b1f47bffee$exports);
$parcel$exportWildcard($93342add5dc68271$exports, $adcb99eda27e89cd$exports);
$parcel$exportWildcard($93342add5dc68271$exports, $f0d920b909797485$exports);
$parcel$exportWildcard($93342add5dc68271$exports, $14213465a09382a1$exports);
$parcel$exportWildcard($93342add5dc68271$exports, $2e65c14677169be3$exports);
$parcel$exportWildcard($93342add5dc68271$exports, $9f6ff16b7ccd9662$exports);
$parcel$exportWildcard($93342add5dc68271$exports, $b3cda162b54b7f9b$exports);
$parcel$exportWildcard($93342add5dc68271$exports, $bc8935a93473b50d$exports);
$parcel$exportWildcard($93342add5dc68271$exports, $49c87fb6bc676a71$exports);






export {$dd2a0a37606c7cc8$export$9a32a8eb4bb56ca3 as default, $dd2a0a37606c7cc8$export$9a32a8eb4bb56ca3 as Reveal, $b828946c3a57391e$export$1736648c5c27c79d as AttentionSeeker, $bb6327b1f47bffee$export$d20e79fdc3899e95 as Bounce, $adcb99eda27e89cd$export$c983850c6c9d8b0e as Fade, $f0d920b909797485$export$4d2fae537bd90431 as Flip, $14213465a09382a1$export$51b1a342f43475b0 as Hinge, $2e65c14677169be3$export$2d9d44ff5c623255 as JackInTheBox, $9f6ff16b7ccd9662$export$aa11096b70371f74 as Roll, $b3cda162b54b7f9b$export$152db69a76b6b79e as Rotate, $bc8935a93473b50d$export$d8dc01b5c85a37b9 as Slide, $49c87fb6bc676a71$export$65cfd44a2050f99 as Zoom};
//# sourceMappingURL=module.js.map
